/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */



export default class
{
  constructor (installCallback)
  {
    this.installCallback = installCallback;

    this.collection = [];
  }


  push (object)
  {
    this.collection.push(object);
  }


  execute ()
  {
    for (const object of this.collection)
    {
      this.installCallback(object)
    }
  }


};
